function Footer() {
  return (
    <footer className="w-full text-center py-4 bg-black text-gray-400 text-sm">
      <p className="flex items-center justify-center gap-1">
        <span className="text-lg">&copy;</span>
        <span>2025 Redcore. All rights reserved.</span>
      </p>
    </footer>
  );
}

export default Footer;
